<span *ngIf="variants">
  <div class="checkbox" *ngFor="let variant of variants">
    <label>
      <span *ngIf="variant.icon" class="icon-size"><fa-icon [icon]="variant.icon"></fa-icon></span>
      <span>{{ variant.description | translate }}</span>
      <input type="radio" [name]="name" [(ngModel)]="value" [value]="variant.value" (click)="onClick($event)"
        (change)="checkedChanged($event)">
      <div></div>
    </label>
  </div>
</span>
